<template>
  <div class="fade-in interview">
    <div class="columns">
      <div class="column is-full">
        <h1 class="title">Interview Log</h1>
      </div>
      <div class="is-clearfix"></div>
    </div>

    <table class="table is-striped">
      <thead>
        <tr>
          <th>Date</th>
          <th>Direction</th>
          <th>Phone</th>
          <th>Name</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in Object.values(log)">
          <td>{{ row.attributes.createdAt | datetime }}</td>
          <td>{{ row.attributes.direction }}</td>
          <td>{{ row.attributes.phoneNumber }}</td>
          <td>{{ row.attributes.name }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="4" class="has-text-centered">
            <button
              v-if="morePages"
              :class="['button', 'is-primary', { 'is-loading': loading }]"
              @click="load"
            >
              More
            </button>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import _ from "lodash";
import InterviewsService from "@/services/InterviewsService";

export default {
  name: "interview-log",

  props: ["id"],

  data() {
    return {
      log: {},
      morePages: false,
      nextPage: 1,
      loading: false
    };
  },

  methods: {
    load() {
      this.loading = true;
      InterviewsService.logs(this.$props.id, this.nextPage).then(response => {
        this.log = Object.assign({}, this.log, response.data);

        this.morePages = false;
        this.nextPage = 1;
        if (_.has(response.links, "next")) {
          const matches = response.links.next.match(/page%5Bnumber%5D=(\d+)&/);
          this.nextPage = matches[1];
          this.morePages = true;
        }
        this.loading = false;
      });
    }
  },

  mounted() {
    this.load();
  }
};
</script>

<style lang="scss" scoped></style>
